import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Container,
  Grid,
  Typography,
  CardMedia,
  Hidden,
  ExpansionPanel as Accordion,
  ExpansionPanelDetails as AccordionDetails,
  ExpansionPanelSummary as AccordionSummary,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const PdfGuide = ({ src, title }) => (
  <Box width="100%">
    <object
      data={`${src}#navpanes=0&scrollbar=1&view=FitH`}
      type="application/pdf"
      title={title}
      style={style.pdfViewer}
    >
      <Typography color="textSecondary">
        Your browser cannot display this PDF. {" "}
        <a href={src} target="_blank" rel="noopener noreferrer">
          Open the PDF in a new tab
        </a>
        .
      </Typography>
    </object>
  </Box>
);

PdfGuide.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

const Guide = () => {
  const [guide, setGuide] = React.useState("register-online");

  return (
    <Container maxWidth="lg">
      <Hidden smDown>
        <Box m={3} mt={5}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={5} md={4} lg={3}>
              <Box
                display="flex"
                flexDirection="column"
                height="calc(100vh - 150px)"
                position="absolute"
              >
                <Typography color="textPrimary" variant="h3">
                  HOW TO:
                </Typography>

                <Box m={2} style={style.pointer}>
                  <Typography
                    color={
                      guide === "register-online"
                        ? "textPrimary"
                        : "textSecondary"
                    }
                    variant="h6"
                    onClick={() => setGuide("register-online")}
                  >
                    CREATE AN ACCOUNT
                  </Typography>
                </Box>
                <Box m={2} style={style.pointer}>

                 <Typography
                    color={
                      guide === "requirements" ? "textPrimary" : "textSecondary"
                    }
                    variant="h6"
                    onClick={() => setGuide("requirements")}
                  >
                    REQUIREMENTS
                    </Typography>
                </Box>

              </Box>
            </Grid>

            <Grid item xs={12} sm={7} md={8} lg={9}>
              <Box p={2}>
                {guide === "register-online" && (
                  <PdfGuide
                    src="/guide/new_account_and_dashboard.pdf"
                    title="Create an Account Guide"
                  />
                )}

                {guide === "requirements" && (
                  <PdfGuide
                    src="/guide/requirements.pdf"
                    title="ERPT Requirements"
                  />
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Hidden>

      <Hidden mdUp>
        <Box mx={1} mt={3} mb={3}>
          <Typography color="textPrimary" variant="h3" gutterBottom>
            HOW TO:
          </Typography>

          <Accordion
            expanded={guide === "register-online"}
            onChange={() =>
              setGuide(guide === "register-online" ? "" : "register-online")
            }
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6">CREATE AN ACCOUNT</Typography>
            </AccordionSummary>
            <AccordionDetails style={style.mobileDetails}> 
              {guide === "register-online" && (
                  <PdfGuide
                    src="/guide/new_account_and_dashboard.pdf"
                    title="Create an Account Guide"
                  />
                )}

            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={guide === "requirements"}
            onChange={() =>
              setGuide(guide === "requirements" ? "" : "requirements")
            }
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6">REQUIREMENTS</Typography>
            </AccordionSummary>
            <AccordionDetails style={style.mobileDetails}>
             
             
                {guide === "requirements" && (
                  <PdfGuide
                    src="/guide/requirements.pdf"
                    title="ERPT Requirements"
                  />
                )}
                
            </AccordionDetails>
          </Accordion>
        </Box>
      </Hidden>
    </Container>
  );
};

export default Guide;

const style = {
  pointer: {
    cursor: "pointer",
  },
  rounded: {
    borderTopRightRadius: "20px",
    borderBottomLeftRadius: "20px",
  },
  pdfViewer: {
    border: 0,
    borderRadius: "8px",
    display: "block",
    height: "calc(100vh - 160px)",
    maxHeight: "calc(100vh - 160px)",
    width: "100%",
  },
  mobileDetails: {
    display: "block",
    padding: 0,
    width: "100%",
  },
  mobileGuide: {
    display: "block",
    height: "auto",
    maxWidth: "100%",
    width: "100%",
  },
};
